/**
 * chat-message-broadcast.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The server transmits a {@link ChatMessageBroadcast} to indicate another
 * user has submitted a chat message for the current subject context.
 */
@validateFor(MessageTag.BCST_CHAT_MESSAGE)
export class ChatMessageBroadcast extends IncomingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.BCST_CHAT_MESSAGE;

    @validateAs("string")
    public message : string;

    @validateAs(["integer", {min: 0}])
    public userId : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/chat-message-broadcast.ts